import "../../stylesheets/contentCard.css";

export default function ContentCard({ children }) {
  return <div className="Content-card">{children}</div>;
}
